import { useMutation } from "@tanstack/react-query";
import { sendQuoteLink } from "../QuoteService";
import { showToast } from "../../../../common/Toaster/Toaster";

const useSendQuoteLink = () =>
  useMutation({
    mutationFn: sendQuoteLink,
    onSuccess: () => {
      showToast("Quote link sent successfully", "success");
    },
    onError: (error) => {
      showToast(
        error?.response?.data?.error_message || "Error while sending quote link",
        "error"
      );
    },
  });

export default useSendQuoteLink;
